import { ChevronLeft, ChevronRight } from 'lucide-react';
import { TooltipButton } from './TooltipButton';

/** Navigation belongs with the thing it moves; presentation only. */
export function WorkspaceStepper({
  label,
  index,
  total,
  previousDisabled,
  nextDisabled,
  onPrevious,
  onNext,
  previousTitle,
  nextTitle,
}: {
  label: 'Document' | 'Page';
  index: number;
  total: number;
  previousDisabled: boolean;
  nextDisabled: boolean;
  onPrevious: () => void;
  onNext: () => void;
  previousTitle: string;
  nextTitle: string;
}) {
  return (
    <div className="workspace-stepper" role="group" aria-label={label}>
      <TooltipButton
        type="button"
        onClick={onPrevious}
        disabled={previousDisabled}
        tooltip={previousTitle}
        aria-description={previousTitle}
        aria-label={`Previous ${label.toLowerCase()}`}
      >
        <ChevronLeft size={17} />
      </TooltipButton>
      <span>
        <em>{label}</em>
        <strong>
          {index.toLocaleString()} <i>/ {total.toLocaleString()}</i>
        </strong>
      </span>
      <TooltipButton
        type="button"
        onClick={onNext}
        disabled={nextDisabled}
        tooltip={nextTitle}
        aria-description={nextTitle}
        aria-label={`Next ${label.toLowerCase()}`}
      >
        <ChevronRight size={17} />
      </TooltipButton>
    </div>
  );
}
